import routerOptions0 from "/app/node_modules/.pnpm/nuxt@4.5.2_b39e155b9d5ab875bcce11a20b66e7bf/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}